import React from "react";
import { Box, Modal } from '@mui/material';
import Video from './Video';

function VideoModal({ open, setOpen }) {
  return (
    <Modal onClose={() => setOpen(false)} open={open}>
      <Box>
        <Video modal />
      </Box>
    </Modal>
  );
}

export default VideoModal;